import { useEffect, useState } from "react";
import api from "../lib/api";
import { CheckCircle2, XCircle, ClipboardCheck } from "lucide-react";

export const RequiredDocsCard = ({ employeeId, refreshKey }) => {
    const [data, setData] = useState(null);

    useEffect(() => {
        if (!employeeId) return;
        api.get(`/documents/required-docs/${employeeId}`)
            .then((r) => setData(r.data))
            .catch(() => {});
    }, [employeeId, refreshKey]);

    if (!data) return null;
    const ok = data.missing_count === 0;

    return (
        <div className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm" data-testid="required-docs-card">
            <div className="flex items-center justify-between">
                <h3 className="flex items-center gap-2 font-display text-sm font-bold text-slate-700">
                    <ClipboardCheck className="h-4 w-4 text-[#376DB3]" />
                    Documenti obbligatori
                </h3>
                <span
                    className={`rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${ok ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`}
                    data-testid="required-docs-badge"
                >
                    {ok ? "Completo" : `${data.missing_count} mancant${data.missing_count === 1 ? "e" : "i"}`}
                </span>
            </div>
            <div className="mt-3 grid grid-cols-1 gap-1.5 sm:grid-cols-2">
                {data.items.map((it) => (
                    <div
                        key={it.key}
                        className={`flex items-center gap-2 rounded-md px-2 py-1.5 text-xs ${it.present ? "text-slate-600" : "bg-red-50 font-semibold text-red-700"}`}
                        data-testid={`required-doc-${it.key}`}
                    >
                        {it.present
                            ? <CheckCircle2 className="h-3.5 w-3.5 flex-shrink-0 text-emerald-500" />
                            : <XCircle className="h-3.5 w-3.5 flex-shrink-0 text-red-500" />}
                        <span className="truncate">{it.label}</span>
                        {it.present && it.count > 1 && (
                            <span className="ml-auto font-mono-numbers text-[10px] text-slate-400">{it.count}</span>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};
